import React from 'react'
import gaiaFlowerSvg from './gaia-flower.svg'

export interface GaiaFlowerProps {
  className?: string
  alt?: string
}

function GaiaFlower ({ className, alt = '' }: GaiaFlowerProps) {
  return (
    <img
      src={gaiaFlowerSvg}
      alt={alt}
      aria-hidden={!alt}
      className={className}
      style={{ display: 'block' }}
    />
  )
}

export default GaiaFlower
